<template>
  <div class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
    <div class="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-2/3 shadow-lg rounded-md bg-white dark:bg-gray-800">
      <div class="flex justify-between items-center pb-3 border-b dark:border-gray-700">
        <h3 class="text-xl font-bold text-gray-900 dark:text-white">Seleccionar Cliente</h3>
        <button @click="$emit('close')" type="button" class="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div class="mt-4">
        <!-- Buscador -->
        <div class="mb-4">
          <input
            v-model="busqueda"
            @input="buscarContactos"
            type="text"
            placeholder="Buscar por nombre, razón social, email, RFC o teléfono..."
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white"
          />
        </div>

        <!-- Lista de contactos -->
        <div class="max-h-96 overflow-y-auto">
          <div v-if="loading" class="text-center py-8 text-gray-500">
            Cargando contactos...
          </div>
          <div v-else-if="contactosFiltrados.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">
            No se encontraron contactos
          </div>
          <div v-else class="space-y-2">
            <div
              v-for="contacto in contactosFiltrados"
              :key="contacto.id"
              @click="seleccionarContacto(contacto)"
              class="p-4 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            >
              <div class="flex justify-between items-start">
                <div class="flex-1">
                  <div class="flex items-center gap-2 mb-1">
                    <p class="font-semibold text-gray-900 dark:text-white">
                      {{ contacto.nombre_completo }}
                    </p>
                    <span
                      :class="getTipoContactoClass(contacto.tipo_contacto)"
                      class="px-2 py-1 text-xs font-medium rounded-full"
                    >
                      {{ getTipoContactoLabel(contacto.tipo_contacto) }}
                    </span>
                  </div>
                  <div class="text-sm text-gray-600 dark:text-gray-400 space-y-1">
                    <p v-if="contacto.rfc">RFC: {{ contacto.rfc }}</p>
                    <p v-if="contacto.email">Email: {{ contacto.email }}</p>
                    <p v-if="contacto.telefono">Tel: {{ contacto.telefono }}</p>
                  </div>
                </div>
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6 flex justify-end">
        <button
          @click="$emit('close')"
          class="px-4 py-2 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-md hover:bg-gray-400 dark:hover:bg-gray-500"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useHttp } from '@/composables/useHttp.js';

const emit = defineEmits(['close', 'select']);

const { get, data } = useHttp();

const contactos = ref([]);
const busqueda = ref('');
const loading = ref(false);

const contactosFiltrados = computed(() => {
  if (!busqueda.value) {
    return contactos.value;
  }

  const termino = busqueda.value.toLowerCase();
  return contactos.value.filter(contacto => {
    return (
      contacto.nombre_completo?.toLowerCase().includes(termino) ||
      contacto.rfc?.toLowerCase().includes(termino) ||
      contacto.email?.toLowerCase().includes(termino) ||
      contacto.telefono?.includes(termino)
    );
  });
});

const cargarContactos = async () => {
  try {
    loading.value = true;
    await get('/contactos?per_page=1000&estatus=activo');
    contactos.value = data.value.data || [];
  } catch (err) {
    console.error('Error al cargar contactos:', err);
  } finally {
    loading.value = false;
  }
};

const buscarContactos = () => {
  // La búsqueda es reactiva con el computed
};

const seleccionarContacto = (contacto) => {
  emit('select', contacto);
  emit('close');
};

const getTipoContactoClass = (tipo) => {
  const classes = {
    mixto: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    fiscal: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
    personal: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300'
  };
  return classes[tipo] || classes.personal;
};

const getTipoContactoLabel = (tipo) => {
  const labels = {
    mixto: 'Mixto',
    fiscal: 'Fiscal',
    personal: 'Personal'
  };
  return labels[tipo] || 'Personal';
};

onMounted(() => {
  cargarContactos();
});
</script>
